import React from "react";
import {
    BrowserRouter as Router,
    Route,
    Switch,
} from "react-router-dom";

import { Game } from "../Game";
import { Landing } from "../Landing";

import "./App.css";

function App() {
    return (
        <Router>
            <div className="app">
                <Switch>
                    <Route exact path="/" component={Landing} />
                    <Route path="*" component={Game} />
                </Switch>
            </div>
        </Router>
    );
}

export default App;
